import React from 'react';

// === Components === //
import Container from '@components/common/Container';

// === Helpers === //
import * as utils from '@utils';

// === Styles === //
import styled from '@emotion/styled';
import { breakpoints, colors, dimensions, fluidRange, respondTo } from '@styles';

// === Types === //
import { Variant } from '@content/types/layout';
import { css } from '@emotion/react';

interface TitleProps {
  text: string;
  variant: Variant;
  alignRight: boolean;
  noMarginTop?: boolean;
}

interface H2Props {
  alignRight: boolean;
  noMarginTop: boolean;
}

const H2 = styled.h2<H2Props>`
  text-align: ${(props) => (props.alignRight ? 'right' : 'left')};
  text-transform: uppercase;
  color: ${colors.text.patientHeader};
  margin: ${(props) => (props.noMarginTop ? '0 0 35px 0' : '60px 0 35px 0')};

  &.variant--red {
    color: ${colors.text.hcpHeader};
  }

  ${respondTo(
    breakpoints.md,
    css`
      text-align: left;
    `
  )}

  p {
    margin: 0;
    font-weight: 700;
    line-height: ${dimensions.lineHeight.heading};
    ${fluidRange('fontSize', '16px', '20px')};
  }
`;

const Title = ({ text, variant, alignRight, noMarginTop = false }: TitleProps) => {
  return (
    <H2 className={`variant--${variant}`} alignRight={alignRight} noMarginTop={noMarginTop}>
      {utils.SafeHtml(text)}
    </H2>
  );
};

export default Title;
